module.exports = __webpack_public_path__ + "img/Avatar-Victoria_AAB-Chat.ee503c1f.png";